export function AccessDenied({ email, onSignOut }) {
  return (
    <div style={{ minHeight:"100vh", background:"#212737", display:"flex", alignItems:"center", justifyContent:"center", fontFamily:"'Poppins','Segoe UI',sans-serif" }}>
      <link href="https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;600;700;800&family=Raleway:wght@400;600;700;800&display=swap" rel="stylesheet"/>
      <div style={{ textAlign:"center", maxWidth:420, padding:40 }}>
        <div style={{ fontSize:48, marginBottom:16 }}>🔒</div>
        <div style={{ fontFamily:"'Raleway',sans-serif", fontSize:22, fontWeight:800, color:"#ffc543", marginBottom:8 }}>Access Denied</div>
        <div style={{ color:"#75788b", fontSize:13, lineHeight:1.6, marginBottom:24 }}>
          <strong style={{ color:"#ffffff" }}>{email}</strong> is not authorised to use this application.
          <br/>Contact your administrator to request access.
        </div>
        <button onClick={onSignOut} style={{ background:"rgba(255,255,255,0.06)", color:"#75788b", border:"1px solid rgba(255,255,255,0.1)", borderRadius:8, padding:"10px 24px", cursor:"pointer", fontSize:13, fontWeight:600 }}>
          Sign Out
        </button>
      </div>
    </div>
  );
}
